import { useQueryClient, useMutation } from "@tanstack/react-query";
import api from "@/lib/api-client";
import { toast } from "react-toastify";

const updatePractice = async (data) => {
    const payload = {
        ...data,
        isAddressSameAsPersonal: data.isAddressSameAsPersonal ? 1 : 0,
        isGroupPractice: data.isGroupPractice ? 1 : 0,
    };

    const res = await api.post("/Clinician/Practice", payload);

    return res.data;
};

export const useUpdatePractice = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updatePractice,
        retry: 1,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["practice"],
            });

            toast.success("Practice successfully updated");
        },
        onError: () => {
            toast.error("Error updating practice");
        },
    });
};
